(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-products-bottom"]) return;
  try {
    

  // When clicking on a collapsible trigger, close all the collapsible pane with the same data-collapsible-target attribute
  const collapsibleTriggers = document.querySelectorAll('[data-collapsible-trigger]');
  collapsibleTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      const target = trigger.getAttribute('data-collapsible-trigger');
      const collapsiblePanes = document.querySelectorAll(`[data-collapsible-target="${target}"]`);
      collapsiblePanes.forEach(function(pane) {
        trigger.classList.toggle('collapsible-trigger--open-lg');
        trigger.classList.toggle('collapsible-trigger--open-xs');
        pane.classList.toggle('collapsible-pane--open-lg');
        pane.classList.toggle('collapsible-pane--open-xs');
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-products-top"]) return;
  try {
    
  const showSaleInfoButton = document.querySelector('[data-product-more-sale]');
  const closeSaleInfoButton = document.querySelector('[data-product-close-sale] .icon svg');
  const saleInfo = document.querySelector('[data-product-more-sale-content]');
  let showSaleInfo = true;
  if (showSaleInfoButton) {
    showSaleInfoButton.addEventListener('click', function() {
      if (showSaleInfo) {
        saleInfo.classList.remove('hidden');
        closeSaleInfoButton.classList.add('flipped');
      } else {
        saleInfo.classList.add('hidden');
        closeSaleInfoButton.classList.remove('flipped');
      }
      showSaleInfo = !showSaleInfo;
    });
  }

  } catch(e) { console.error(e); }
})();
      })();
